export class TblLeadStatus {
  refNo: number;
  statusName: string;
  colorScheme: string;
  followupRequired: string;
}
